
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { MessageSquarePlus, MessageSquare, Lightbulb, Bug } from "lucide-react";
import { FeedbackForm } from "./FeedbackForm";
import { FeedbackList } from "./FeedbackList";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

interface FeedbackProps {
  showPricing?: boolean;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

interface FeedbackDialogContentProps {
  onOpenChange?: (open: boolean) => void;
}

export const Feedback = ({ showPricing = false, open, onOpenChange }: FeedbackProps) => {
  if (showPricing) return null;

  // No longer showing the floating button version
  // Only rendering the controlled dialog for menu integration
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px] p-0 gap-0 rounded-2xl">
        <FeedbackDialogContent onOpenChange={onOpenChange} />
      </DialogContent>
    </Dialog>
  );
};

// Extracted common dialog content to avoid duplication
const FeedbackDialogContent = ({ onOpenChange }: FeedbackDialogContentProps) => {
  return (
    <>
      <div className="p-8 pb-6 border-b">
        <DialogHeader>
          <DialogTitle className="text-[32px] font-bold tracking-tight">
            Share Your Thoughts
          </DialogTitle>
          <div className="flex gap-3 mt-4">
            <Badge variant="secondary" className="bg-blue-50 text-blue-700 hover:bg-blue-100 rounded-lg">
              <MessageSquare className="w-3 h-3 mr-1" />
              Feedback
            </Badge>
            <Badge variant="secondary" className="bg-amber-50 text-amber-700 hover:bg-amber-100 rounded-lg">
              <Lightbulb className="w-3 h-3 mr-1" />
              Ideas
            </Badge>
            <Badge variant="secondary" className="bg-red-50 text-red-700 hover:bg-red-100 rounded-lg">
              <Bug className="w-3 h-3 mr-1" />
              Bugs
            </Badge>
          </div>
        </DialogHeader>
      </div>
      
      <Tabs defaultValue="list" className="w-full">
        <div className="px-8 border-b">
          <TabsList className="w-full h-auto p-0 bg-transparent gap-8">
            <TabsTrigger 
              value="list" 
              className="data-[state=active]:bg-transparent data-[state=active]:shadow-none data-[state=active]:text-blue-600 px-0 py-4 border-b-2 border-transparent data-[state=active]:border-blue-600 rounded-none"
            >
              Browse
            </TabsTrigger>
            <TabsTrigger 
              value="submit" 
              className="data-[state=active]:bg-transparent data-[state=active]:shadow-none data-[state=active]:text-blue-600 px-0 py-4 border-b-2 border-transparent data-[state=active]:border-blue-600 rounded-none"
            >
              Submit
            </TabsTrigger>
          </TabsList>
        </div>
        
        <div className="px-8 py-6">
          <TabsContent value="list" className="mt-0">
            <FeedbackList />
          </TabsContent>
          
          <TabsContent value="submit" className="mt-0">
            <FeedbackForm onSubmit={() => onOpenChange?.(false)} />
          </TabsContent>
        </div>
      </Tabs>
    </>
  );
};
